import moment from 'moment';
import { Button, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import React, { useMemo, useState } from "react";
import { StickyTable } from 'datastake-daf/dist/components';
import Island from './island';
import ExpandedRowEvent from "./expandedRowEvent";

const tabs = [
  {
    key: 'incidents',
    label: 'Incidents',
  },
  {
    key: 'correctiveActions',
    label: 'Corrective Actions',
  },
  {
    key: 'other',
    label: 'Other',
  },
];
const initialSelected = {
  incidents: [],
  correctiveActions: [],
  other: [],
};

export default function Unconfirmed({
  columns = [],
  data = {},
  setAsRelevant = () => { },
  setAsUnRelevant = () => { },
  inputLabel = [],
}) {
  const [activeTab, setActiveTab] = useState('incidents');
  const { t: tr } = useTranslation();
  const [selectedRowKeys, setSelectedRowKeys] = useState(initialSelected);
  const [toggledKeys, setToggledKeys] = useState(initialSelected);

  const allSelected = useMemo(() => {
    return Object.values(selectedRowKeys).reduce((all, item) => {
      return [...all, ...item];
    }, []);
  }, [selectedRowKeys]);

  const legend = useMemo(() => ({
    incidents: {
      label: tr('Incidents'),
      value: (data.incidents || []).length,
      color: '#F5222D',
    },
    correctiveActions: {
      label: tr('Actions'),
      value: (data.correctiveActions || []).length,
      color: '#52C41A',
    },
    other: {
      label: tr('Other'),
      value: (data.other || []).length,
      color: '#FFC586',
    },
  }), [tr, data]);

  const lastUpdate = useMemo(() => {
    let all = [];

    Object.values(data).forEach((val) => {
      all.push(...val);
    });

    all = all.map((ev) => ev.date)
      .sort((a, b) => moment(b).diff(moment(a)));

    if (all[0]) {
      return all[0];
    }

    return null;
  }, [data]);

  const onChangeSelected = (type, val) => {
    setSelectedRowKeys((prev) => ({ ...prev, [type]: val }));
  }

  const onToggleChanged = (type, val) => {
    setToggledKeys((prev) => ({ ...prev, [type]: val }));
  };

  return (
    <Island
      headerText={tr('Unconfirmed Events')}
      desc={inputLabel.join('. ')}
      t={tr}
      legend={legend}
      lastUpdate={lastUpdate}
    >
      <Tabs activeKey={activeTab} onChange={setActiveTab}
        items={tabs.map((t) => ({
          key: t.key,
          tabKey: t.key,
          label: `${tr(t.label)} (${(data[t.key] || []).length})`,
          children: (
            <StickyTable
              columns={columns}
              dataSource={data[t.key]}
              rowKey="id"
              rowSelection={{
                selectedRowKeys: selectedRowKeys[t.key],
                onChange: (val) => onChangeSelected(t.key, val),
              }}
              rowKey="id"
              size="small"
              expandable={{
                expandedRowRender: (record) => <ExpandedRowEvent event={record} />,
                rowExpandable: () => true,
                expandedRowKeys: toggledKeys[t.key],
                onExpandedRowsChange: (rows) => onToggleChanged(t.key, rows),
              }}
              rowClassName={(rec) => toggledKeys[t.key].includes(rec.key) ? 'expanded' : ''}
            />
          )
        }))}
      />
      <div className="buttons">
        <Button
          disabled={allSelected.length === 0}
          onClick={() => {
            setAsUnRelevant(allSelected);
            setSelectedRowKeys(initialSelected);
          }}
        >
          {tr('Not Relevant')}
        </Button>
        <Button
          type="primary"
          disabled={allSelected.length === 0}
          onClick={() => {
            setAsRelevant(allSelected);
            setSelectedRowKeys(initialSelected);
          }}
        >
          {tr('Relevant')}
        </Button>
      </div>
    </Island>
  );
}